<oaibox-stats-card title="Tenant Assignment" icon="fa-duotone fa-solid fa-building-magnifying-glass" gradient="warning">
  <div class="form p-g">
    <div class="dropdown">
      <label for="selected-tenants" class="form-label">Tenants</label>
      <button type="button" class="form-control" data-bs-toggle="dropdown">
        @if (selectedTenants.length > 0) {
          <div id="selected-tenants">
            @for (tenant of selectedTenants; track tenant.id) {
              <oaibox-tenant-info [tenant]="tenant"></oaibox-tenant-info>
            }
          </div>
        } @else {
          <span class="text-muted">Select tenant</span>
        }
        <span class="dropdown-toggle"></span>
      </button>

      <ul class="dropdown-menu tenants-list" role="menu">
        <input type="text" class="form-control search-input" placeholder="Search" spellcheck="false" [formControl]="searchInputControl">

        @for (tenant of shownTenants; track tenant.id) {
          @let selected = selectedTenants.includes(tenant);

          <li role="menuitem">
            <button type="button" class="dropdown-item" [class.selected]="selected" (click)="onSelectTenant(tenant)">
              <div class="tenant-info-wrapper">
                <oaibox-tenant-info [tenant]="tenant"></oaibox-tenant-info>

                @if (selected) {
                  <i class="fa-solid fa-circle-check selected-tenant"></i>
                }
              </div>
            </button>
          </li>
        }
      </ul>
    </div>

    <div class="buttons-wrapper">
      <button type="button" class="btn btn-ignore" (click)="closeModal()">
        Cancel
      </button>
      <button type="button" class="btn btn-success save-button" [disabled]="selectedTenants.length <= 0" (click)="assignTenant()">
        Save
      </button>
    </div>
  </div>
</oaibox-stats-card>
